import ServiceOutageBlocker from "@Components/app/notifications/ServiceOutageBlocker";
import { AppContext } from "@Context/common/general/context";
import { useCallback, useContext } from "react";
import { defineNotificationModule, INotificationResolverProps } from "../notification-service.types";
import { useNotificationCandidate } from "../use-notification-candidate";
import { useNotificationActions } from "../shared/use-notification-actions";
import { usePlatformNotificationState } from "../shared/use-platform-notification-state";

const id = "SERVICE_OUTAGE_BLOCKER";

const ServiceOutageBlockerNotificationResolver = ({ priority }: INotificationResolverProps) => {
  const { state } = useContext(AppContext);
  const { handleExit } = useNotificationActions();
  const { isServiceOutageMode } = usePlatformNotificationState();

  const render = useCallback(() => (
    <ServiceOutageBlocker
      open={isServiceOutageMode}
      onExit={handleExit}
      isUnityEmbedded={state.device.isUnityEmbedded}
      isSuperAdmin={state.user.isSuperAdmin}
    />
  ), [handleExit, isServiceOutageMode, state.device.isUnityEmbedded, state.user.isSuperAdmin]);

  useNotificationCandidate({
    id,
    priority,
    isActive: isServiceOutageMode,
    render,
  });

  return null;
};

export const serviceOutageBlockerNotification = defineNotificationModule({
  id,
  Resolver: ServiceOutageBlockerNotificationResolver,
});
